export const locale = {
  lang: 'en',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
        'ADMIN': 'Group manager',
        'CREAR': 'Create group',
        'EDITAR': 'Edit group',
        'APLICAR': 'Apply',
        'NAME':'Group name',
        'DESCRIPCION': 'Description',
        'FILTROS': 'Filters',
        'ACCION': 'Actions',
        'EDIT': 'Edit',
        'DELETE': 'Delete'
      },
      'CREAR': {
        'DATO': 'Group data',
        'NAME': 'Group name',
        'DESCRIPCION': 'Group description',
        'FILTROS': 'Filters',
        'FILSELEC': 'Selected filters',
        'COUNTRY': 'Country',
        'CARGO': 'Position or function',
        'ANTIG': 'Antiquity',
        'GENDER': 'Gender'
      },
      'REACTIVOS': {
        'SIN': 'You have not done the statements selection yet',
        'STEPS': {
          '1': {
              'TITULO': 'Statements selection',
              'DISPONIBLES': 'Available templates: ',
              'LISTADO': {
                'TITULO': 'Select the statements for a list you want the survey to be built',
                'SUBTITULO': 'Choose a template from the list to show its statement list',
                'PICKEDTITU': 'Statement list for template: ',
                'PICKEDTOT': 'Available statements: ',
                'PICKEDNUM': 'Chosen statements: ',
              }
          },
          '2': {
              'TITULO': 'Translations'
          },
          '3': {
              'TITULO': 'Previsualización',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organization Perspective',
                  'AREA': 'Workgroup Perspective',
                  'BOTONES': {
                    '0': 'It is almost always false',
                    '1': 'It is often false',
                    '2': 'Sometimes it´s fake / Sometimes it´s true',
                    '3': 'It is often true',
                    '4': 'It is almost always true'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
        }
      }
    },
    'CERTIFICAR': {
      'TITUTEST': 'ASDGF',
      'IDIOMAS': {
        'ELEGIR': 'Choose',
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'MENSAJES':{
          'ADDLANG': 'You chose ',
          'NOADITIONAL': 'You chose not to set additional languages',
          'ERRORADD': 'An error ocurred while choosing the language ',
          'LANGDEL': 'You removed ',
          'NOADITIONALDEL': 'You canceled the option not to set additional languages',
          'ERRORDEL': 'An error ocurred while removing the language ',
          'MAINPICKED': 'You have already chose the survey main language.<br><br>To change it, remove the selected language and choose a new one.'
        },
        'CARD1': {
          'TITULO': 'Main language',
          'ACCION': {
            'PRE': 'You have not selected the main language',
            'POST': 'You selected the language:'
          },
          'MODAL': {
            'TITULO': 'Choose the main language',
            'ACCION': 'Which language is the survey main language?',
            'PLACELISTA': 'Choose a language',
            'BOTONES': {
              'BACK': 'Back',
              'OK': 'Ready'
            }
          }
        },
        'CARD2': {
          'TITULO': 'Additional languages',
          'ACCION': {
            'PRE': 'You have not selected additional languages',
            'SINADIC': 'The survey will not have additional languages',
            'POST': 'You selected the following languages:'
          },
          'MODAL': {
            'TITULO': 'Choose additional languages',
            'ACCION': 'Which languages you want to add to the survey?',
            'BOTONES': {
              'BACK': 'Back',
              'OK': 'Ready'
            }
          }
        }
      },
      'NPS': {
        'CONFIGURE_QUESTION': 'Press here to display the NPS',
        'ADD': 'Create a statement',
        'QUESTIONUPDATEDOK': 'NPS updated successfully',
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': 'Translate',
          'TAB3': 'Preview',
        }
      },
      'REACTIVOS': {
        'CONFIGURE_QUESTION': 'Press here to display the reagent',
        'ADD': 'Create a statement',
        'QUESTIONUPDATEDOK': 'Statement updated successfully',
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'TABS': {
          'TAB1': 'Statements',
          'TAB2': 'Translate',
          'TAB3': 'Preview',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': 'Click here to display the control question',
        'ADD': 'Create a statement',
        'QUESTIONUPDATEDOK': 'Control question successfully updated',
        'STATUS': {
          'PEND': 'Complete step',

          'DONE': 'Step completed'
        },
        'TABS': {
          'TAB1': 'Control question',
          'TAB2': 'Statements',
          'TAB3': 'Translate',
        }
      },
      'DEMOGRAFICOS': {
        'TAB1': 'Demographic',
        'TAB2': 'Translations',
        'TAB3': 'Preview',
        'COMPLETAR_PASO': 'Complete step',
        'PASO_COMPLETADO': 'Step completed',
        'SELECT': 'Select an option',
        'BTN_DEMOGRAFICOS': 'Accept',
        'OPTION_SURVEY': 'Survey',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': 'Both',
        'CLAVE': 'Clave',
        'RESPONSE_NOT_ADDED': 'You cannot add answers to an open question',
        'CONFIGURE_QUESTION': 'Click here to display the question',
        'QUESTION': 'Question',
        'OPCIONES_RESPUESTA': 'Response options',
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'EXPANSION':{
          'Work Responsability' : 'Work Responsability',
          'Trust Level' : 'Trust Level',
          'Innovation' : 'Innovation',
          'Disabilities' : 'Disabilities',
          'Ethnic Group' : 'Ethnic Group',
          'Personal Responsabilities' : 'Personal Responsabilities',
          'Gender' : 'Gender',
          'Work Location' : 'Work Location',
          'Travel' : 'Travel',
          'Living Location' : 'Living Location',
          'Marital Status' : 'Marital Status',
          'Home Type' : 'Home Type',
          'Home Location' : 'Home Location',
          'Home Status' : 'Home Status',
          'Transport' : 'Transport',
          'Sports' : 'Sports',
          'Weight' : 'Weight',
          'Sleep' : 'Sleep',
          'Home Office' : 'Home Office',
          'Languages' : 'Languages',
          'Work Experience' : 'Work Experience',
          'Social Networks' : 'Social Networks',
          'Employ Opportunities' : 'Employ Opportunities',
          'Inspiration' : 'Inspiration',
          'Meetings' : 'Meetings',
          'Tenure' : 'Tenure',
          'Clave': 'Clave',
          'Ege': 'Ege',
          'Work Status': 'Work Status',
          'Education': 'Education',
          'Hierarchical Level': 'Hierarchical Level',
          'Confidence Decisions': 'Confidence Decisions',
          'Work Innovation': 'Work Innovation',
          'Belong': 'Belong',
          'Converse Performance': 'Converse Performance',
          'Work Years':'Work Years',
          'Generation':'Generation',
          'Confidence In Decisions': 'Confidence In Decisions',
          'Develop New Things': 'Develop New Things',
          'Reason To Stay':'Reason To Stay',
          'Age':'Age',
          'Type Of Job':'Type Of Job',
          'Minoritate':'Minoritate',
          'Sindicat':'Sindicat',
          //TURQUIA//
          'Confidence':'Confidence',
          'Opportunities':'Opportunities',
          'Managerial Level':'Managerial Level',
          'Years Of Service':'Years Of Service',
          'Ethnic':'Ethnic',





        }
      },
      'FORALL': {
        'MSJ_PRACTICEREGISTERED': 'Practice saved succesfully',
        'MSJ_DESCRIPTIONREGISTERED': 'Description saved succesfully',
        'MSJ_TRANSLATEREGISTERED': 'Practice translated successfully',
        'MSJ_DESCRIPTIONTRANSLATED': 'Description translated successfully',
        'QUESTIONUPDATEDOK': 'Question updated successfully.',
        'QUESTIONUPDATEDFAIL': 'Error, insert a valid question',
        'RESPONSEUPDATEDOK': 'Response updated successfully.',
        'RESPONSEUPDATEDFAIL': 'Error, insert a valid response text',
        'TRANSLATEDOK': 'Question translate saved succesfully',
        'INSERTTRANSLATE': 'Please, insert the translate',
        'OPTIONTRANSLATED': 'Option translate saved succesfully',
        'INSERTOPTIONTRANSLATE': 'Please, insert the translate',
        'MJS_SELECTOPTION': 'Please select an option',
        'MJS_OPTIONADDED': 'Demographic added correctly',
        'OPTIONDELETED': 'Demographic deleted succesfully',
        'RESPONSEOPTIONDELETED': 'Response successfully eliminated',
        'DEMOGRAPHICEXIST': 'The demographic selected already exist',
        'AGREGADEMOGRAFICO': 'Select to add more demographics',
        'MSJ_PRACTICEREQUIRED': 'Practice is required!',
        'MSJ_DESCRIPTIONREQUIRED': 'Description is required!',
        'CARGANDO_PRACTICA': 'Saving practice, please wait...',
        'CARGANDO_DESCRIPCION': 'Saving description, please wait...',


        'SELECCIONE': 'Select a language to show the preview',
        'IDIOMAS_NOT_SELECTED': 'Additional languages are not selected to translate.',
        'PLACEHOLDER': 'Language',
        'DESC_TRANSLATE': 'Enter description translate',
        'DESC_TRANSLATE_DEMO': 'Enter the translation of the answer',
        'DESC_TRANSLATE_FORALL': 'Enter the translation of the description',
        'PRACTICE_TRANSLATE_REACTIVOS': 'Enter the translation of the statements',
        'PRACTICE_TRANSLATE_ABIERTAS': 'Enter the translation of the open question',
        'PRACTICE_TRANSLATE_FORALL': 'Enter the practice translation',
        'PRACTICE_TRANSLATE_DEMO': 'Enter the translation of the demographic',
        'IDIOMAS': {
          'Native': 'Native',
          'es': 'Spanish',
          'zh1': 'Traditional Chinese',
          'zh2': 'Simplified Chinese',
          'pt': 'Portuguese',
          'en': 'English',
          'vi': 'Vietnamese'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'Sí',
          'no':'No',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'Si','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'Yes','no':'No',
          'casifalso':'Almost always untrue',
          'false': 'Often untrue',
          'avecesfalse': 'Sometimes untrue/ sometimes true',
          'casiverdad': 'Often true',
          'verdad': 'Almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'}
        },
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': 'Main language',
            'TRADUCCION': 'Translations',
            'PREVIEW': 'Preview'
          },
          'ENCABEZADOS': {
            'PRACT': 'Practice name',
            'DESCR': 'Description',
            'STT1': 'Statement 1',
            'STT2': 'Statement 2',
            'LANG': 'Language'
          },
          'INPUTS': {
            'PRACT': 'Enter the practice name',
            'DESCR': 'Enter the description text'
          }
        }
      },
      'ABIERTAS': {
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'TABS': {
          'TAB1': 'Open questions',
          'TAB2': 'Translate',
          'TAB3': 'Preview',
        }
      },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION':'Sent to authorization',
          'AUTORIZACION-OK':'Your survey has been authorized, proceed to complete the step',

        },
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'TABS': {
          'QUESTIONS': 'Additional questions',
          'TRANSLATE': 'Translations',
          'PREVIEW': 'Preview'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': 'You have not created any additional questions',
            'CON': 'Questions created:',
            'NOADICIONALES': 'You choose not to create additional questions',
            'CANCELNOADIC': 'You canceled the option not to create additional questions',
            'ERROR': 'An error occurred while performing the operation'
          },
          'ACCIONES': {
            'ADD': 'Create a question',
            'SIN': 'The survey will not have additional questions'
          },
          'WIZARD': {
            'NEW': 'New question',
            'TIPOTITU': 'Click here to configure the additional question',
            'TIPO': {
              'OPEN': 'Open question',
              'UNI': 'Single option question',
              'MULT': 'Multiple option question'
            },
            'FORM': {
              'TIPO': 'Type of question',
              'TOOLTIP': {
                'REMOVE': 'Remove this question'
              },
              'MENSAJES': {
                'BORRAR': 'Do you want to delete this additional question?',
                'PREG_OK': 'The question was saved successfully',
                'PREG_ERR': 'An error occurred while saving the question',
                'PREG_MOD_OK': 'The question was modified correctly',
                'PREG_MOD_ERR': 'An error occurred while modifying the question',
                'OPC_OK': 'The answer option was saved successfully',
                'OPC_ERR': 'An error occurred while saving the answer option',
                'OPC_MOD_OK': 'The answer option was modified correctly',
                'OPC_MOD_ERR': 'An error occurred while modifying the answer option',
                'PREG_DEL_OK': 'The question was deleted successfully',
                'PREG_DEL_ERR': 'An error occurred while deleting the question',
                'OPC_DEL_OK': 'The answer option was deleted successfully',
                'OPC_DEL_ERR': 'An error occurred while deleting the answer option'
              },
              'BOTONES':{
                'SI': 'Yes',
                'NO': 'No'
              }
            },
            'ABIERTA': {
              'TITULO': 'New open question',
              'ACCION': 'Enter the question text',
              'ERROR': 'You have not entered the question text'
            },
            'MULTI':{
              'TITULOSING': 'New single option question',
              'TITULOMULT': 'New multiple option question',
              'ACCION': 'Enter the question text',
              'ERROR': 'You have not entered the question text',
              'MENSAJES': {
                'BORRAR': 'Do you want to delete this answer option?',
                'SINPREG': 'You cannot enter any option until you enter the question text',
                'SINANTE': 'You cannot enter this answer option text until you enter the previous answer option text'
              },
              'OPCIONES': {
                'TITU': 'Answer options',
                'INPUT': {
                  'TITU': 'Answer option',
                  'ERROR': 'You have not entered the text for the answer option'
                }
              },
              'TOOLTIP': {
                'ADD': 'Add an answer option',
                'MOVE': 'Move answer option',
                'REMOVE': 'Remove this answer option'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': 'Select a language to start entering the translation texts',
          'TITULOALTERNO': 'You did not select any additional language in the "Languages" section',
          'NOTYET': 'Translation not yet completed.',
          'MAIN': 'Main language',
          'INPUT': {
            'NEW': 'Enter the question translation',
            'ERROR': 'You have not entered the question translation!',
            'NEWOPC': 'Enter the answer option translation',
            'ERROROPC': 'You have not entered the answer option translation!'
          },
          'MENSAJES': {
            'PREG_OK': 'The translation text was saved successfully',
            'PREG_ERR': 'An error occurred while saving the translation text',
            'PREG_MOD_OK': 'The translation text was updated correctly',
            'PREG_MOD_ERR': 'An error occurred while updating the translation text',
            'OPC_NOPREG': 'The translation text for this option cannot be saved until the question text is set',
            'OPC_OK': 'The translation text was saved successfully',
            'OPC_ERR': 'An error occurred while saving the translation text',
            'OPC_MOD_OK': 'The translation text was updated correctly',
            'OPC_MOD_ERR': 'An error occurred while updating the translation text'
          },
          'COMPLETE': 'Translation complete '
        },
        'PREVIEW': {
          'TITULO': 'Select a language to show the additional questions translations',
          'SINPREV': 'There are no translated texts for the selected language',
          'LOADING': 'Loading data',
          'INPUT': {
            'RESPABIERTA': 'Write your answer',
            'ERRORABIERTA': 'You have not written your answer!',
            'ELIGELANG': 'Choose a language'
          },
          'HELP': {
            'SINGLE': 'You may choose only an option in this question',
            'MULTI': 'You may choose more than one option in this question'
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': 'Complete step',
          'DONE': 'Step completed'
        },
        'STATUSBAR': {
          'NOBD': 'You have not loaded your participants database',
          'PROCES': 'The participants database is not stored yet',
          'ERROR': 'Errors were found in the loaded file',
          'OK': 'The participants database is correctly stored'
        },
        'CARD_BD': {
          'TITULO': 'Information',
          'NUMCOLABS': 'Number of participants',
          'FECHA': 'Upload date',
          'ACCIONES': 'Actions',
          'WANNADO': 'What do you want to do?',
          'BOTONES': {
            'DESCARGA': 'Download the participants database',
            'ELIMINA': 'Delete the participants database'
          }
        },
        'CARD_NOBD': {
          'TITULO': 'Follow this steps to upload your participants information',
          'PASOS': {
            '1': 'Download the participants database template',
            '2': 'Fill the template with your participants information based on the provided columns',
            '3': 'Upload the file with your participants information'
          },
          'TOOLTIP': 'This file includes data validation macros',
          'FILE': 'Collaborators List Template file'
        },
        'CARD_NOERR': {
          'TITULO': 'Information',
          'NUMCOLABS': 'Number of participants in the loaded file',
          'FILENAME': 'Name of file',
          'GUARDAR': 'Do you want to store this information?',
          'BOTONES': {
            'SI': 'Yes',
            'NO': 'No'
          }
        },
        'CARD_ERRFND': {
          'TITULO': 'Information',
          'ROWS_OK': 'Number of correct rows',
          'ROWS_NOTOK': 'Number of rows with errors',
          'MOREINFO': '* The error list in detail is shown below',
          'FILENAME': 'Name of file',
          'GUARDAR': 'The loaded information cannot be stored',
          'DELETE': 'Delete file'
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': 'Rows with errors: ',
            '2': 'Total errors found: '
          },
          'INFO': {
            'ROW': 'Row ',
            'ERRNUM': 'Number of errors: ',
            'SHOW': 'Click here to show this row errors'
          },
          'DETALLE': {
            'TIPO': 'Type of error',
            'DESCR': 'Description',
            'COLUMNA': 'Column',
            'DATO': 'Wrong data'
          },
          'ERRORES': {
            'alfabetica': 'Alphabetic invalid data',
            'alfanumerica': 'Alphanumeric invalid data',
            'numerica': 'Numerical invalid data',
            'email': 'Email invalid syntax',
            'vacio': 'Empty cell',
            'columna': 'Unknown column',
            'catSurvey': 'Unknown data',
            'repetido': 'Repeated data'
          },
          'DESCRIPCION': {
            'alfabetica': 'The information has one or more invalid characters. Only alphabetic characters (A - Z) and the next special characters: [( ) . , : -] are allowed ',
            'alfanumerica': 'The information has one or more invalid characters. Only alphabetic characters (A - Z), numerical (0 - 9) and the next special characters: [( ) . , : -] are allowed ',
            'numerica': 'The information has one or more invalid characters. Only numerical characters (0 - 9) are allowed',
            'email': 'The information does not have the right email syntax ( mail@domain.com )',
            'vacio': 'The cell has no information. This column is mandatory.',
            'columna': 'The column does not belong to the template provided',
            'catSurvey': 'The cell information does not match any option entered in the Demographics section of the platform',
            'repetido': 'This cell has repeated information from another cell in the same column. Repeated data is not allowed in this column.'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': 'Loading',
            'INFO': 'Analyzing the file information, wait a moment please'
          },
          'GUARDA': {
            'TITULO': 'Saving',
            'INFO': 'Storing the information into the system, stay in this screen until the saving process is finished'
          },
        },
        'MENSAJES': {
          'GUARDA_1': 'Do you confirm to store the information of ',
          'GUARDA_2': ' participants?',
          'GUARDADO': 'The participants database was stored successfully',
          'GUA_ERR': 'An error occurred while storing the information. Try again later',
          'DELETE_1': 'Do you confirm to delete the information of ',
          'DELETE_2': ' collaborators?',
          'DEL_OK_1': 'The information of ',
          'DEL_OK_2': ' collaborators was deleted successfully',
          'DEL_ERR': 'An error occurred while deleting the collaborators database. Try again later',
          'DELFILE': 'The participants database file was removed correctly',
          'EXCEL': 'Generating Excel file, wait a moment please',
          'EXTMAL': 'The selected file does not have the right extension. Only uploading the template file provided by plataform is allowed',
          'NOROWS': 'The selected file does not have any record',
          'VACIO': 'The selected file is empty, or the collaborators information is not in the first sheet',
          'BOTONES': {
            'SI': 'Yes',
            'NO': 'No'
          }
        },
        'EXCELINFO': {
          'HOJA': 'Collaborators data',
          'TITULO': 'Collaborators database',
          'AUTOR': 'Plataform',
          'ASUNTO': 'Downloaded from platform'
        },
        'UPLOAD': 'Click here to browse the participants database',
        'REMOVE': 'Remove from upload',
        'SEND': 'Send to database',
        'PROCESO': {
          'STP1': 'Analyzing the collaborators database',
          'STP2': 'Saving the collaborators database'
        }
      }
    }
  }
};
